export default class SoundManager {
    static _instance = null

    constructor() {
        if(SoundManager._instance){
            return SoundManager._instance;
        }

        this.el = document.querySelector('.sounds')
        this.currentlyPlaying = null
        this.playing = false
        this._controls = []
        // this._tracks = []
        // this._audioContexts = new AudioContext()
        // this._gains = []
        // this._setupTracks()

        SoundManager._instance = this
    }

    _setupTracks() {
        this.el.querySelectorAll('audio').forEach((audio) => {
            this._tracks[audio.id] = this._audioContext.createMediaElementSource(audio)
            this._gains[audio.id] = this._tracks[audio.id].connect(this._audioContext.createGain()).connect(this._audioContext.destination)
        })

    }

    setVolume(volume) {
        // console.log('set volume', volume, this.currentlyPlaying)
        this.el.querySelector("#" + this.currentlyPlaying).volume = volume
    }

    addControl (who) {
        this._controls.push(who)
    }

    pauseSound (callback) {
        console.log('will pause', this.currentlyPlaying)
        if (this.currentlyPlaying) {
            this._decreaseVolume(callback)
        }
    }

    stopSound() {
        this.el.querySelectorAll("audio").forEach((track) => {
            track.volume = 0
            track.pause()
            track.currentTime = 0
        })
        this.currentlyPlaying = null
        this.playing = false
        this._setControls()
    }

    _stopSound() {
        if (this.el.querySelector("#" + this.currentlyPlaying).volume === 0) {
            this.el.querySelector("#" + this.currentlyPlaying).pause()
            this.el.querySelector("#" + this.currentlyPlaying).currentTime = 0;
            this.el.querySelector("#" + this.currentlyPlaying).removeEventListener('ended', window._soundManager.playMain)
        }
        this.currentlyPlaying = null
        this.playing = false
        this._setControls()
    }

    playMain () {
        window._soundManager.playSound('main')
    }

    playSound (what) {
        if (this.currentlyPlaying === what) {
            console.log('already playing', this.currentlyPlaying)
            return
        }
        if (this.currentlyPlaying) {
            console.log('playing', this.currentlyPlaying)
            this.pauseSound(()=>{this._play(what)})
            return
        }
        this._play(what)
    }

    _play (what) {
        console.log('will play', what)
        this.el.querySelector("#" + what).volume = 0
        this.el.querySelector("#" + what).play()
        this.currentlyPlaying = what
        this.playing = true
        this._increaseVolume()
        this.el.querySelector("#" + what).addEventListener('ended', window._soundManager.playMain, false);
        this._setControls()
    }

    _increaseVolume(volume) {
        let maxVolume = parseFloat(this.el.querySelector("#" + this.currentlyPlaying).dataset.maxVolume)
        if (volume === undefined) {
            volume = parseFloat(this.el.querySelector("#" + this.currentlyPlaying).dataset.minVolume)
        }
        if (volume < maxVolume) {
            window.setTimeout(() => {
                this.setVolume(volume)
                this._increaseVolume(volume+=0.1)
            }, 50)
        } else {
            this.setVolume(maxVolume)
        }
    }

    _decreaseVolume(callback, volume ) {
        let minVolume = parseFloat(this.el.querySelector("#" + this.currentlyPlaying).dataset.minVolume)
        if (volume === undefined) {
            volume = parseFloat(this.el.querySelector("#" + this.currentlyPlaying).dataset.maxVolume)
        }

        if (volume > minVolume) {
            window.setTimeout(() => {
                this.setVolume(volume)
                this._decreaseVolume(callback,volume-=0.1)
            }, 50)
        } else {
            this.setVolume(minVolume)
            this._stopSound()
            if (callback) {
                callback()
            }
        }
    }

    _setControls() {
        console.log('sending status update')
        this._controls.forEach((control) => {
            if (typeof control.setStatus === "function") {
                control.setStatus(this.playing)
            } else {
                console.warn('cannot set status of a Control')
            }
        })
    }
}
window._soundManager = new SoundManager()
